export default class DeliveryEvent {
  constructor(name, value1 = null, value2 = null) {
    this.name = name;
    this.value1 = value1;
    this.value2 = value2;
  }
}